import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CoreStateService, SchoolService } from '@app/core/services';
import { isEmpty } from 'lodash-es';
import { map, Observable, Subject, switchMap } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-card-structure',
  templateUrl: './card-structure.component.html',
  styleUrls: ['./card-structure.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardStructureComponent implements OnInit, OnDestroy {
  public structures$: Observable<any>;

  public isShowNormalCarousel$: Observable<boolean>;

  private _destroy$ = new Subject<void>();

  constructor(
    private escolaService: SchoolService,
    private coreStateService: CoreStateService,
    private breakpointObserver: BreakpointObserver,
  ) {}

  public ngOnInit() {
    this.structures$ = this.coreStateService.school$.pipe(
      switchMap((res) => this.escolaService.structure(res.id)),
      filter((data) => !isEmpty(data.estruturas)),
    );
    this.isShowNormalCarousel$ = this.breakpointObserver.observe('(min-width: 1280px)').pipe(
      takeUntil(this._destroy$),
      map((state) => state.matches),
    );
  }

  public ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
